import { LuPackage, LuStore } from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('appstore', '/apps', null, [
    ['header', 'appstore.header', LuStore],
    ['grid', 'appstore.grid', LuPackage, { placement: 'top', ...opt }],
  ]),
];

export default tours;
